export default class DonationMeter {
  constructor(element) {
    this.element = element
    this.init()
  }

  init() {
    // Get data from element:
    const dataElement = this.element.querySelector('.js-donationmeter-range')

    // Calculate needed values:
    let rangeCurrentText
    let range25Text
    let range50Text
    let range75Text
    let rangeGoalText
    let rangePriceperunit

    if (dataElement.dataset.rangeTypegoal == 'GoalInUnits') {
      let currentConverted = dataElement.dataset.rangeCurrent / dataElement.dataset.rangePriceperunit
      currentConverted = Math.round(currentConverted).toLocaleString('nl-NL')

      if (currentConverted > 1) {
        rangeCurrentText = currentConverted + ' ' + dataElement.dataset.rangeUnitnameplural
      } else {
        rangeCurrentText = currentConverted + ' ' + dataElement.dataset.rangeUnitnamesingular
      }

      range25Text =
        Math.round(dataElement.dataset.rangeGoal * 0.25).toLocaleString('nl-NL') +
        '<span class="hidden--palm"> ' +
        dataElement.dataset.rangeUnitnameplural +
        '</span>'
      range50Text =
        Math.round(dataElement.dataset.rangeGoal * 0.5).toLocaleString('nl-NL') +
        '<span class="hidden--palm"> ' +
        dataElement.dataset.rangeUnitnameplural +
        '</span>'
      range75Text =
        Math.round(dataElement.dataset.rangeGoal * 0.75).toLocaleString('nl-NL') +
        '<span class="hidden--palm"> ' +
        dataElement.dataset.rangeUnitnameplural +
        '</span>'
      rangeGoalText =
        Math.round(dataElement.dataset.rangeGoal).toLocaleString('nl-NL') +
        '<span class="hidden--palm"> ' +
        dataElement.dataset.rangeUnitnameplural +
        '</span>'

      rangePriceperunit = dataElement.dataset.rangePriceperunit
    } else {
      rangeCurrentText = '€ ' + Math.round(dataElement.dataset.rangeCurrent).toLocaleString('nl-NL') + ',-'

      range25Text = '€ ' + Math.round(dataElement.dataset.rangeGoal * 0.25).toLocaleString('nl-NL') + ',-'
      range50Text = '€ ' + Math.round(dataElement.dataset.rangeGoal * 0.5).toLocaleString('nl-NL') + ',-'
      range75Text = '€ ' + Math.round(dataElement.dataset.rangeGoal * 0.75).toLocaleString('nl-NL') + ',-'
      rangeGoalText = '€ ' + Math.round(dataElement.dataset.rangeGoal).toLocaleString('nl-NL') + ',-'

      // Bij eenheid euro is price per unit altijd 1:
      rangePriceperunit = 1
    }

    // Populate the data in HTML elements:
    const rangeCurrent = this.element.querySelector('.js-customrange .js-customrange-current')
    const rangeTrackLeft = this.element.querySelector('.js-customrange .js-customrange-track-left')
    const rangeCurrentSign = this.element.querySelector('.js-customrange .js-customrange-currentsign')

    this.element.querySelector('.js-customrange .js-customrange-current-text').innerHTML = rangeCurrentText
    this.element.querySelector('.js-customrange .js-customrange-label-25').innerHTML = range25Text
    this.element.querySelector('.js-customrange .js-customrange-label-50').innerHTML = range50Text
    this.element.querySelector('.js-customrange .js-customrange-label-75').innerHTML = range75Text
    this.element.querySelector('.js-customrange .js-customrange-label-100').innerHTML = rangeGoalText

    let currentPercentage =
      ((dataElement.dataset.rangeCurrent / rangePriceperunit) * 100) / dataElement.dataset.rangeGoal

    if (currentPercentage > 100) {
      currentPercentage = 100
    }

    rangeCurrentSign.style.left = currentPercentage + '%'
    rangeCurrent.style.left = currentPercentage + '%'
    rangeTrackLeft.style.width = currentPercentage + '%'

    // Set checkmarks:
    if (currentPercentage >= 25) {
      this.element.querySelector('.js-customrange .js-customrange-point-25').classList.add('reached')
    }

    if (currentPercentage >= 50) {
      this.element.querySelector('.js-customrange .js-customrange-point-50').classList.add('reached')
    }

    if (currentPercentage >= 75) {
      this.element.querySelector('.js-customrange .js-customrange-point-75').classList.add('reached')
    }

    if (currentPercentage == 100) {
      this.element.querySelector('.js-customrange .js-customrange-point-100').classList.add('reached')
    }
  }
}
